import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Flex } from "Components/_Shared/Core/Flex";
import { Empty } from "Components/_Shared/Empty";
import { IconBadge, type IconBadgeColor } from "Components/_Shared/IconBadge";
import { NsureClientCaseStateCaseStatus } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { ResourcePathType } from "Infrastructure/Translations/Resources";

type Props = {
  caseStatus: NsureClientCaseStateCaseStatus | null;
};

type StatusConfig = {
  titleKey: ResourcePathType;
  icon: React.ReactElement;
  color: IconBadgeColor;
};

const statusConfigs: Partial<Record<Exclude<NsureClientCaseStateCaseStatus, null>, StatusConfig>> = {
  [NsureClientCaseStateCaseStatus.InSignature]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.InSignature,
    icon: <InfoOutlined sx={{ fontSize: 35 }} />,
    color: "info",
  },
  [NsureClientCaseStateCaseStatus.Signed]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Signed,
    icon: <CheckCircleOutlined sx={{ fontSize: 35 }} />,
    color: "success",
  },
  [NsureClientCaseStateCaseStatus.Done]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Done,
    icon: <CheckCircleOutlined sx={{ fontSize: 35 }} />,
    color: "success",
  },
  [NsureClientCaseStateCaseStatus.Rejected]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Rejected,
    icon: <WarningAmberIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
  [NsureClientCaseStateCaseStatus.Cancelled]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Cancelled,
    icon: <WarningAmberIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
  [NsureClientCaseStateCaseStatus.Error]: {
    titleKey: Resources.Questionnaire.InvestmentCaseStatus.StatusTitles.Error,
    icon: <WarningAmberIcon sx={{ fontSize: 35 }} />,
    color: "warning",
  },
};

const fallbackConfig: StatusConfig = {
  titleKey: Resources.Questionnaire.InvestmentCaseStatus.Title,
  icon: <WarningAmberIcon sx={{ fontSize: 35 }} />,
  color: "warning",
};

export const InvestmentsNsureCaseStatus = ({ caseStatus }: Props) => {
  const { t } = useResource();

  const config = (caseStatus && statusConfigs[caseStatus]) ?? fallbackConfig;

  return (
    <Flex pt={Spacing.XXL}>
      <Empty
        title={t(config.titleKey)}
        text={t(Resources.Questionnaire.InvestmentCaseStatus.Text)}
        icon={<IconBadge color={config.color} icon={config.icon} />}
      />
    </Flex>
  );
};
